export const cashierShiftDefaults = {
    idBankAccount: "",        // A conta bancária do tipo "CASH" (Caixa Físico)
    operatorId: "",           // ID de quem abriu o caixa
    operatorName: "",         // Nome do operador responsável pelo caixa
    status: "OPEN",           // OPEN ou CLOSED
    dateString: "",           // Timestamp formatado YYYY-MM-DD para queries rápidas
    
    openedAt: null,           // Timestamp de abertura
    openingBalance: 0,        // Saldo Físico inicial (Troco de abertura)
    
    closedAt: null,           // Timestamp de fechamento
    closingBalance: 0,        // Saldo Físico final Informado pelo operador (Fechamento cego)
    systemComputedBalance: 0, // Saldo que o sistema achava que deveria ter
    difference: 0,            // closingBalance - systemComputedBalance (Sobrou ou faltou)
    
    createdAt: null,
    updatedAt: null
};
